import { useCollectionProgress } from '../collectionProgress';
import { useCardsCollections } from '../collectionsList';
var useFetchedCollectionData = function (collectionIdOrAlias, onFetchError) {
    var _a;
    var cardsCollection = ((_a = useCollectionProgress(collectionIdOrAlias, onFetchError)) !== null && _a !== void 0 ? _a : {}).collection;
    var _b = useCardsCollections(), partiallyFetchedCollections = _b.items, loading = _b.loading;
    if (cardsCollection) {
        return { collection: cardsCollection, loading: loading };
    }
    var collectionFromBanner = partiallyFetchedCollections.find(function (collection) {
        return collection._id === collectionIdOrAlias ||
            collection.urlAlias === collectionIdOrAlias;
    });
    return { collection: collectionFromBanner, loading: loading };
};
export default useFetchedCollectionData;
